(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[661],{

/***/ 661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _googleMap_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9226);
/* harmony import */ var _googleMap_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_googleMap_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var GoogleMap = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), showIframe = ref[0], setShowIframe = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleScroll = function() {
            if (!showIframe) {
                setShowIframe(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.048217020971!2d44.505611!3d40.172600!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4041f1e8173d8bf5%3A0x0!2s26a%20Movses%20Khorenatsi%20Street!5e0!3m2!1sen!2sus!4v<timestamp>",
                    width: "100%",
                    height: "100%",
                    loading: "lazy"
                }));
            }
        };
        if (!showIframe) {
            window.addEventListener("scroll", handleScroll);
        } else {
            window.removeEventListener("scroll", handleScroll);
        }
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_googleMap_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["footer-google_map"]),
        children: showIframe
    });
};
/* harmony default export */ __webpack_exports__["default"] = (GoogleMap);


/***/ }),

/***/ 9226:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer-google_map":"googleMap_footer-google_map__vUFkv"};

/***/ })

}]);